/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { ZetaChild } from './zeta-child';

export function ZetaGroup(props) {
  const activePane = (props.app && props.app.activePane) || props.activePane || '';
  const { app, data, em, size, addClass } = props;
  const template = props.template || (em && em.template) || [];

  let klassName = '';
  switch (size) {
    case 'full':
      klassName = 'col-12';
      break;

    case 'large':
      klassName = 'col-sm-10 offset-sm-1';
      break;

    case 'medium':
      klassName = 'col-sm-8 offset-sm-2';
      break;

    case 'half':
      klassName = 'col-sm-6';
      break;

    default:
      klassName = 'col';
      break;
  }

  const visible = em && em.pane && em.pane !== '' && em.pane !== activePane ? 'd-none' : '';

  return (
    <div className={`${klassName} ${addClass || ''} ${visible || ''}`}>
      {em && em.title && em.title !== '' && <h6 className="mt-4 font-weight-bold text-primary">{em.title}</h6>}
      {template &&
        template.map((t, i) => {
          // TODO : if (t.toggle) return <></>;
          // See sample in content-row.js : t.toggle

          const _t = { ...t, parentSize: size };
          switch (t.type.toLowerCase()) {
            case 'hr':
              return <hr key={i} />;

            default:
              return <ZetaChild key={i} em={_t} app={app} data={data} onChange={props.onChange} />;
          }
        })}
      {props.children}
    </div>
  );
}
